import React from 'react';

import CommonImage from '@/components/CommonImage';
const UpdateSampleDetailModal = () => {
	return (
		<div className="popup-wrapper">
			<div className="common-popup update-sample-detail-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Update task</h3>
					</div>
					<div className="close-btn">
						<CommonImage alt="close" src="/icons/close.svg" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="update-sample-detail-table">
						<table className="table with-border">
							<thead>
								<tr>
									<th>Color</th>
									<th>Color details</th>
									<th>Size</th>
									<th>Qty</th>
									<th>
										<span className="custom-tooltip">
											<p>Whom to send sample</p>
											<span className="tooltiptext left-0">
												If a person needs two samples, select his name twice.
											</span>
										</span>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<CommonImage
											alt="color"
											src="/icons/Add.svg"
											Width={24}
											Height={24}
										/>
									</td>
									<td>Color details</td>
									<td>Size</td>
									<td>Qty</td>
									<td>Whom to send sample</td>
								</tr>
								<tr>
									<td>
										<span className="color-icon" style={{ background: '#000' }}></span>
									</td>
									<td>Color details</td>
									<td>Size</td>
									<td>Qty</td>
									<td>
										<div className="chip-container d-flex align-items-center">
											<div className="chip gray-chip">
												<span>Factory</span>
												<span className="chip-close cursor-pointer">
													<CommonImage
														alt="close"
														src="/icons/close.svg"
														Width={14}
														Height={14}
													/>
												</span>
											</div>
											<div className="chip gray-chip">
												<span>Factory</span>
												<span className="chip-close cursor-pointer">
													<CommonImage
														alt="close"
														src="/icons/close.svg"
														Width={14}
														Height={14}
													/>
												</span>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button outline size32 ml-2">Cancel</button>
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UpdateSampleDetailModal;
